import React, { useContext } from 'react';
import { IWatchContext, WatchContext } from '../../../watchState/watchContext';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

export const IsActiveCheckbox: React.FC = () => {
	const { toggleIsActive, isActive } = useContext<IWatchContext>(WatchContext);

	return (
		<Checkbox checked={isActive} onChange={toggleIsActive} data-test="IsActiveCheckbox">
			<Text translationNameSpace="listing" translationKey="isShowOnlyActiveLabel" asFragment={true} />
		</Checkbox>
	);
};
